import styles from './Search.module.scss';
import { SearchWithToolTipProps } from '../../types/props/SearchWithToolTipProps';
import { TextInput } from '@cxc/react-fpds-components';
import { CancelCloseFilled, Search } from '@cxc/react-fpds-icons-v1';

const SearchWithToolTip = ({
    error,
    errorText,
    label,
    required,
    tooltip,
    value,
    placeholder,
    onChange,
}: SearchWithToolTipProps) => {
    const handleChange = (inputValue: string) => {
        onChange(inputValue);
    };

    return (
        <div className={styles.searchWithTooltip}>
            <TextInput
                placeholder={placeholder}
                textSize="small"
                helperTextProp={{
                    secondaryProp: {
                        // @ts-expect-error - This is a known issue with the FPDS component library
                        state: error,
                        helperText: errorText,
                    },
                }}
                value={value}
                data-testid="zip-code-search"
                required={required}
                labelProp={{
                    label: label,
                }}
                onChange={(e) => {
                    handleChange(e.target.value);
                }}
                infoProp={{
                    infoText: tooltip,
                }}
                startAdornmentProp={{ startAdornment: <Search /> }}
                endAdornmentProp={{
                    endAdornment: value ? (
                        <CancelCloseFilled onClick={() => handleChange('')} />
                    ) : (
                        ''
                    ),
                }}
            />
        </div>
    );
};

export default SearchWithToolTip;
